import React, { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Typography, Button, makeStyles } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  container: {
    width: 400,
    height: 150,
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    backgroundColor: '#fff'
  },
  imagePreview: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    opacity: 0,
    transition: "opacity 0.3s ease",
    "&:hover": {
      opacity: 1,
    },
  },
}));

const SignatureUploader = ({ onChange, initialSignatureUrl }) => {
  const classes = useStyles();
  const [preview, setPreview] = useState(initialSignatureUrl);

  useEffect(() => {
    setPreview(initialSignatureUrl);
  }, [initialSignatureUrl]);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }, [onChange]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/png': ['.png'] },
    maxFiles: 1,
    onDropRejected: () => {
      toast.error("Formato no válido. Solo se aceptan imágenes PNG.");
    }
  });

  return (
    <Box>
      <div {...getRootProps()} className={classes.container}>
        <input {...getInputProps()} />
        {preview ? (
          <>
            <img src={preview} alt="Vista previa de la firma" className={classes.imagePreview} />
            <div className={classes.overlay}>
              <EditIcon />
            </div>
          </>
        ) : isDragActive ? (
          <Typography>Suelta la imagen aquí...</Typography>
        ) : (
          <Typography color="textSecondary">Arrastra y suelta tu firma PNG, o haz clic para seleccionarla.</Typography>
        )}
      </div>
    </Box>
  );
};

export default SignatureUploader;